import React, { useRef, useState, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { oneUpdate, oneRemove } from '~data/actions/collections'
import { getSearchEmpty } from '~data/selectors/bookmarks'

import { Confirm, Prompt } from '~co/overlay/dialog'
import { Button, Icon, Menu, MenuItem, Popover } from '~ui'
import ChangeIcon from '~co/collections/changeIcon'

export default function BookmarksHeaderMore({ spaceId = 0, collection = {} }) {
    const dispatch = useDispatch()
    const isSearching = useSelector(state => !getSearchEmpty(state, spaceId))

    const pin = useRef(null)
    const [menu, setMenu] = useState(false)
    const [icon, setIcon] = useState(false)

    const onContextMenuClick = useCallback(e => {
        e.preventDefault()
        setMenu(prev => !prev)
    }, [])

    const onContextMenuClose = useCallback(() => setMenu(false), [])
    const onIconClick = useCallback(() => setIcon(true), [])
    const onIconClose = useCallback(() => setIcon(false), [])

    const onRenameClick = useCallback(async () => {
        const newname = await Prompt(t.s('rename'), collection.title)
        if (newname)
            dispatch(oneUpdate(collection._id, { title: newname }))
    }, [dispatch, collection._id, collection.title])

    const onRemoveClick = useCallback(async () => {
        if (
            await Confirm(t.s('areYouSure'), {
                variant: 'warning',
                description: collection._id != -99 ? t.s('collectionDeleteConfirm') : '',
                ok: collection._id != -99 ? (t.s('remove') + ' ' + collection.title) : t.s('emptyTrash')
            })
        )
            dispatch(oneRemove(collection._id))
    }, [dispatch, collection._id, collection.title])

    const { _id, access } = collection
    if (isSearching || _id <= 0 || !access || access.level < 3) return null

    return (
        <>
            <Button
                variant='ghost'
                ref={pin}
                title={t.s('more')}
                onMouseDown={onContextMenuClick}>
                <Icon name='more_horizontal' />
            </Button>

            {menu && (
                <Popover
                    pin={pin}
                    onClose={onContextMenuClose}>
                    <Menu>
                        <MenuItem onClick={onRenameClick}>
                            <Icon name='edit' />
                            {t.s('rename')}
                        </MenuItem>

                        <MenuItem onClick={onIconClick}>
                            <Icon name='image' />
                            {t.s('changeIcon')}
                        </MenuItem>

                        <MenuItem onClick={onRemoveClick}>
                            <Icon name='trash' />
                            {t.s('removeCollection')}
                        </MenuItem>
                    </Menu>
                </Popover>
            )}

            {icon ? (
                <ChangeIcon
                    _id={_id}
                    onClose={onIconClose} />
            ) : null}
        </>
    )
}
